<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3 class="sp-color__accent">
      {{ 'SELLERS.EDIT_CTA_PHONE' | translate }}
    </h3>
    <form
      [formGroup]="seller_edit_phone_form_group"
      class="sp-margin__top-x2 sp-width__full sp-row__space sp-wrap">
      <mat-form-field
        class="sp-width__one-third sp-margin__bottom-x2"
        [floatLabel]="'always'"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'GENERAL.PHONE_PREFIX_LABEL' | translate }}
        </mat-label>
        <img
          *ngIf="current_country_prefix"
          class="sp-flag sp-margin__left sp-margin__top-x2"
          matPrefix
          [src]="current_country_prefix.flag" />
        <img
          *ngIf="!current_country_prefix"
          class="sp-flag sp-margin__left sp-margin__top-x2"
          matPrefix
          [src]="unknown_flag_src" />
        <input
          matInput
          type="email"
          formControlName="phone_prefix"
          [errorStateMatcher]="error_matcher"
          [matAutocomplete]="autocountry"
          required />
        <mat-autocomplete
          class="sp-form__autocomplete"
          autoActiveFirstOption
          #autocountry="matAutocomplete"
          (optionSelected)="onCountryPrefixSelect()">
          <mat-option
            *ngFor="let country_prefix of filtered_prefixes | async"
            class="sp-flag__option"
            [value]="country_prefix.code">
            <app-shared-country-prefix [country_prefix]="country_prefix"></app-shared-country-prefix>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field
        class="sp-width__two-thirds sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'GENERAL.PHONE_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="phone_value"
          [errorStateMatcher]="error_matcher"
          required />
      </mat-form-field>

      <app-shared-button
        class="sp-width__full"
        [button_class]="'sp-button__main'"
        [spinner_class]="'sp-spinner__main'"
        [cta]="'GENERAL.CONFIRM_CTA'"
        [is_disabled]="!isFormValid() || is_seller_edit_running"
        [is_spinner_visible]="is_seller_edit_running"
        (click)="onConfirmClick()"></app-shared-button>
    </form>
  </div>
</div>
